import { deprecated, Struct } from "superstruct";

export function deprecatedWithLog<T>(struct: Struct<T>, message: string) {
  return deprecated(struct, () => console.debug(message));
}
